/** @format */

import type ITirCropperVars from "./ITirCropperVars";

export default class TirCropperVarsModel implements ITirCropperVars {
  "--tir-cropper-active-border" = "#33ccff";
  "--tir-cropper-active-border-style" = "dotted";
  "--tir-cropper-background" = "#525266";
  "--tir-cropper-border" = "#e9e9f2";
  "--tir-cropper-border-style" = "solid";
  "--tir-cropper-border-width" = "1px";
  "--tir-cropper-opacity" = "0.75";
  "--tir-cropper-point-active-background" = "#33ccff";
  "--tir-cropper-point-active-border" = "#33ccff";
  "--tir-cropper-point-active-border-style" = "solid";
  "--tir-cropper-point-active-opacity" = "0.25";
  "--tir-cropper-point-active-radius" = "50%";
  "--tir-cropper-point-active-size" = "18px";
  "--tir-cropper-point-background" = "#e9e9f2";
  "--tir-cropper-point-border" = "#e9e9f2";
  "--tir-cropper-point-border-style" = "solid";
  "--tir-cropper-point-border-width" = "1px";
  "--tir-cropper-point-opacity" = "0.25";
  "--tir-cropper-point-radius" = "4px";
  "--tir-cropper-point-size" = "16px";
  "--tir-cropper-transition-duration" = "0.15s";
  "--tir-cropper-transition-timing-function" = "ease-in-out";
  constructor(obj?: Partial<TirCropperVarsModel>) {
    if (obj) Object.assign(this, obj);
  }
  static setVars(vars: TirCropperVarsModel) {
    const styleElement = document.createElement("style");
    let varsStr = "";
    Object.keys(vars).forEach((key) => {
      varsStr += `${key}: ${vars[key as keyof TirCropperVarsModel]};\n`;
    });
    styleElement.textContent = `
  :root {
    ${varsStr}
  }
`;
    document.head.appendChild(styleElement);
  }
}
